"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');



const getOrgOnboardingSurveyActions = _utils.createAsyncActions('GetOrgOnboardingSurvey')
const getDemoSchedulingStatusActions = _utils.createAsyncActions('GetDemoSchedulingStatus')

 const actionCreators = {
  getOrgOnboardingSurveyActions,
  getDemoSchedulingStatusActions,
}; exports.actionCreators = actionCreators

// Member-readable fetch of the org's onboarding survey answers (OrgKey required —
// the backend validates it and auth-gates on org membership). Read-only: no store
// mutation. A missing survey resolves to empty strings, never an error.
const getOrgOnboardingSurvey = (req) =>
  _helpers.wsCommand('GetOrgOnboardingSurvey', getOrgOnboardingSurveyActions, req, null)

// Live state of the Calendly demo event (exists? current custom questions?)
// so the demo step can skip a deleted event and never prefill a reordered
// question. Read-only; server-cached.
const getDemoSchedulingStatus = (req) =>
  _helpers.wsCommand('GetDemoSchedulingStatus', getDemoSchedulingStatusActions, req, null)

exports. default = {
  getOrgOnboardingSurvey,
  getDemoSchedulingStatus,
}
